var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleAnalytics = function SvgGoogleAnalytics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bb5a365a-816f-4291-9c4f-ad24c6172eb9",
    "data-name": "svg4243",
    viewBox: "0 0 450 154.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "bd010793-6947-4399-b3ca-41f1583cc30a",
    "data-name": "glyph8-1",
    viewBox: "0 0 10.7 11.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a8dd662b-39a9-4233-80bf-5081e0252fd7",
    "data-name": "path1196",
    d: "M5.3,10,3.4,4.6H7.3L5.4,10ZM1.7,0H0L4.5,11.9H6.2L10.7,0H9L7.8,3.2h-5Z",
    style: {
      fill: "#747474"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "a799807e-060e-4109-86f3-31a2d26e3de6",
    "data-name": "glyph8-2",
    viewBox: "0 0 7.2 8.4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fa4418b9-1a0e-4f4d-bd4d-26dfb51a12ac",
    "data-name": "path1199",
    d: "M0,8.1H1.5V7h0A3.6,3.6,0,0,0,2.6,8a2.8,2.8,0,0,0,1.5.4,2.9,2.9,0,0,0,2.3-.9,3.3,3.3,0,0,0,.8-2.4V0H5.7V5c-.1,1.3-.7,2-2,2a1.9,1.9,0,0,1-1.6-.8,2.4,2.4,0,0,1-.6-1.7V0H0Z",
    style: {
      fill: "#747474"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b5f514ba-f78b-4c4c-88db-b6ac3606b34a",
    "data-name": "glyph8-3",
    viewBox: "0 0 7.2 8.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a9a58360-fa44-47b9-9f0b-215db93e4fc2",
    "data-name": "path1202",
    d: "M1.6,2.8a1,1,0,0,1,.5-1,1.6,1.6,0,0,1,1.2-.4A2.3,2.3,0,0,1,5,2.1a2.1,2.1,0,0,1,.7,1.7,3.4,3.4,0,0,1-2,.5,2.4,2.4,0,0,1-1.5-.4A1.4,1.4,0,0,1,1.6,2.8ZM3.5,8.7a3.7,3.7,0,0,0,2.7-.9,3.3,3.3,0,0,0,1-2.5V.3H5.7V1.4h0A3.1,3.1,0,0,0,3.1,0,3.3,3.3,0,0,0,.9.8a2.5,2.5,0,0,0-.9,2,2.3,2.3,0,0,0,1,2,3.7,3.7,0,0,0,2.5.7A3.8,3.8,0,0,0,5.7,5v.4a1.6,1.6,0,0,1-.6,1.3,2,2,0,0,1-1.5.6,2.4,2.4,0,0,1-2-1.1L.3,7.1A3.8,3.8,0,0,0,3.5,8.7Z",
    style: {
      fill: "#747474"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b31ee9a4-de42-46f7-b06a-dbc87ccd728b",
    "data-name": "glyph8-4",
    viewBox: "0 0 1.5 11.9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "be3d8199-1bab-4c71-8a4a-623096e659c1",
    "data-name": "path1205",
    d: "M1.5,11.9V0H0V11.9Z",
    style: {
      fill: "#747474"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "ef3f478d-2505-4e15-b4d8-1e168cc46955",
    "data-name": "glyph8-5",
    viewBox: "0 0 8.1 11.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e879892e-83f3-4700-a006-66d264926a4d",
    "data-name": "path1208",
    d: "M8.1,11.7,3,0H1.5L3.4,4.1,0,11.7H1.7L4.1,5.9h0l2.4,5.8Z",
    style: {
      fill: "#747474"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "a413485c-3f95-41a2-b91e-21d934a7959a",
    "data-name": "glyph8-6",
    viewBox: "0 0 5.1 10.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ffdec559-8b47-4a3d-b8b4-54628f68fecb",
    "data-name": "path1211",
    d: "M3.8,0A2.4,2.4,0,0,0,2.1.6a2.4,2.4,0,0,0-.7,1.7V6.9H0V8.2H1.4v2.5H3V8.2H5V6.9H3V2.8a1.6,1.6,0,0,1,.3-1.1A.9.9,0,0,1,4,1.4h.7L5.1.2Z",
    style: {
      fill: "#747474"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "bd3fbdd7-4ebd-4301-a9e5-f982fb5d26f0",
    "data-name": "glyph8-7",
    viewBox: "0 0 2.2 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f93d42ed-9c9e-482e-8a17-afeedccf1c38",
    "data-name": "path1214",
    d: "M2.2,10.9a1,1,0,0,0-.4-.7.8.8,0,0,0-.7-.4.9.9,0,0,0-.8.4.9.9,0,0,0-.3.7,1.1,1.1,0,0,0,.3.8,1.1,1.1,0,0,0,.8.3.9.9,0,0,0,.7-.3A1.2,1.2,0,0,0,2.2,10.9ZM1.8,8.1V0H.3V8.1Z",
    style: {
      fill: "#747474"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "afcee1fe-c3aa-49d4-babd-bdaf96f31baf",
    "data-name": "glyph8-8",
    viewBox: "0 0 7.8 8.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ba95f0b2-e034-42b7-a00d-09b6f3ae2370",
    "data-name": "path1217",
    d: "M4.2,0a4.1,4.1,0,0,0-3,1.2A4.5,4.5,0,0,0,0,4.3,4.1,4.1,0,0,0,1.2,7.4a4.2,4.2,0,0,0,3,1.3A3.8,3.8,0,0,0,6.3,8,3.3,3.3,0,0,0,7.7,6.3L6.3,5.7A2.1,2.1,0,0,1,4.1,7.3a2.3,2.3,0,0,1-1.8-.9,2.9,2.9,0,0,1-.8-2.1,3.2,3.2,0,0,1,.8-2.1,2.5,2.5,0,0,1,1.8-.8A2.3,2.3,0,0,1,6.4,2.9l1.4-.6A3.9,3.9,0,0,0,6.4.6,4,4,0,0,0,4.2,0Z",
    style: {
      fill: "#747474"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "af3309e3-b12f-437e-a000-dc1870dff519",
    "data-name": "glyph8-9",
    viewBox: "0 0 6.8 8.7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a1be20e1-eaf5-4f0e-8283-56ce0e2ad2a8",
    "data-name": "path1220",
    d: "M6.8,2.5A2.4,2.4,0,0,0,5.8.7,3.5,3.5,0,0,0,3.5,0,4.3,4.3,0,0,0,1.3.6,4.3,4.3,0,0,0,0,2.3l1.4.6a2.4,2.4,0,0,1,.8-1.1,2,2,0,0,1,1.3-.4,2.1,2.1,0,0,1,1.2.3c.3.2.5.4.5.7S4.8,3.3,4,3.6l-1.4.3C1,4.3.2,5.1.2,6.2A2.3,2.3,0,0,0,1.1,8a4.3,4.3,0,0,0,2.4.7,3.3,3.3,0,0,0,1.9-.6A2.5,2.5,0,0,0,6.6,6.8L5.3,6.2a2,2,0,0,1-.8.8,2.1,2.1,0,0,1-1.2.3,1.7,1.7,0,0,1-1-.3c-.3-.2-.5-.4-.5-.7s.4-.8,1.3-1L4.3,5C5.9,4.6,6.8,3.7,6.8,2.5Z",
    style: {
      fill: "#747474"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "a23ff488-dadf-4ac7-97ff-0ecb83903135",
    "data-name": "g6562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fcfc19ea-005a-4865-aa72-058e502cd5e0",
    "data-name": "path6536",
    d: "M264.5,42.1a20,20,0,0,1-39.9,0,20,20,0,0,1,39.9,0Zm-8.7,0c0-7.2-5.2-12.1-11.3-12.1s-11.2,4.9-11.2,12.1,5.2,12.1,11.2,12.1S255.8,49.2,255.8,42.1Z",
    transform: "translate(0 0)",
    style: {
      fill: "#747474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "f19f6e04-375c-47c7-8dc5-ffb4833e7e72",
    "data-name": "path6538",
    d: "M307.6,42.1a20,20,0,0,1-39.9,0c0-11.6,8.9-19.9,20-19.9A19.5,19.5,0,0,1,307.6,42.1Zm-8.7,0c0-7.2-5.2-12.1-11.2-12.1s-11.3,4.9-11.3,12.1,5.2,12.1,11.3,12.1S298.9,49.2,298.9,42.1Z",
    transform: "translate(0 0)",
    style: {
      fill: "#747474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "e2c2062c-2fe8-41a6-93b5-d586e133fed5",
    "data-name": "path6540",
    d: "M349,23.4V59.1c0,14.8-8.7,20.8-19,20.8a19,19,0,0,1-17.6-11.8L320,65a11,11,0,0,0,10,7c6.6,0,10.6-4,10.6-11.7V57.5h-.3A13.5,13.5,0,0,1,329.8,62c-9.9,0-19-8.7-19-19.8s9.1-20,19-20a13.8,13.8,0,0,1,10.5,4.4h.3V23.4Zm-7.7,18.8c0-7.1-4.7-12.2-10.7-12.2s-11.1,5.1-11.1,12.2,5.1,12,11.1,12S341.3,49.1,341.3,42.2Z",
    transform: "translate(0 0)",
    style: {
      fill: "#747474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b97ca218-f92e-4cf5-bbb9-65290569e4ad",
    "data-name": "path6542",
    d: "M362.6,2.4V60.8h-8.5V2.4Z",
    transform: "translate(0 0)",
    style: {
      fill: "#747474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b4cc4234-aa77-44d9-b561-d5f789e64fe3",
    "data-name": "path6544",
    d: "M395.9,48.6l6.8,4.6A20,20,0,0,1,386.1,62a19.5,19.5,0,0,1-19.8-19.9c0-11.9,8.5-19.9,18.8-19.9s15.4,8.2,17.1,12.6l.9,2.3-26.7,11c2.1,4,5.2,6.1,9.7,6.1s7.5-2.2,9.8-5.6ZM375,41.5l17.8-7.4c-1-2.5-3.9-4.2-7.4-4.2A10.9,10.9,0,0,0,375,41.5Z",
    transform: "translate(0 0)",
    style: {
      fill: "#747474"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "bbb72e2c-ad52-42a6-98ca-2b8695a18fff",
    "data-name": "path6546",
    d: "M192.3,36.9V28.5h28.4a25.1,25.1,0,0,1,.5,5.1c0,6.3-1.8,14.1-7.4,19.7S201.5,62,192.3,62c-17.1,0-31.4-13.9-31.4-30.9S175.2.1,192.3.1a29.4,29.4,0,0,1,21.2,8.6l-6,5.9a21.4,21.4,0,0,0-15.2-6,22.2,22.2,0,0,0-22.2,22.5,22.2,22.2,0,0,0,22.2,22.5,21,21,0,0,0,15.6-6.2c2.4-2.4,3.9-5.8,4.6-10.5Z",
    transform: "translate(0 0)",
    style: {
      fill: "#747474"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b00f95c2-712d-4ff2-8f97-09851b681510",
    "data-name": "g6607"
  }, /*#__PURE__*/React.createElement("use", {
    id: "bf4b3b14-df4d-452a-aff6-b20967e3d816",
    "data-name": "use3812",
    width: 10.7,
    height: 11.88,
    transform: "matrix(4.53, 0, 0, -4.53, 160.27, 138.67)",
    xlinkHref: "#bd010793-6947-4399-b3ca-41f1583cc30a"
  }), /*#__PURE__*/React.createElement("use", {
    id: "e42b0f2a-30e2-4fe0-93a1-40c56f4b8377",
    "data-name": "use3814",
    width: 7.2,
    height: 8.39,
    transform: "matrix(4.53, 0, 0, -4.53, 212.07, 138.67)",
    xlinkHref: "#a799807e-060e-4109-86f3-31a2d26e3de6"
  }), /*#__PURE__*/React.createElement("use", {
    id: "a38d00f2-74e6-435f-bb60-fb6fdaec4f7c",
    "data-name": "use3818",
    width: 7.2,
    height: 8.66,
    transform: "matrix(4.53, 0, 0, -4.53, 250.33, 139.87)",
    xlinkHref: "#b5f514ba-f78b-4c4c-88db-b6ac3606b34a"
  }), /*#__PURE__*/React.createElement("use", {
    id: "e0a1129f-dc8c-42a9-965c-0c024c88360f",
    "data-name": "use3820",
    width: 1.5,
    height: 11.88,
    transform: "matrix(4.53, 0, 0, -4.53, 290.39, 138.67)",
    xlinkHref: "#b31ee9a4-de42-46f7-b06a-dbc87ccd728b"
  }), /*#__PURE__*/React.createElement("use", {
    id: "f689e2f0-401a-4e5b-9644-52f032ad829c",
    "data-name": "use3822",
    width: 8.1,
    height: 11.7,
    transform: "matrix(4.53, 0, 0, -4.53, 301.3, 154.87)",
    xlinkHref: "#ef3f478d-2505-4e15-b4d8-1e168cc46955"
  }), /*#__PURE__*/React.createElement("use", {
    id: "e2735794-8eb9-43fb-b379-80a749dc092e",
    "data-name": "use3826",
    width: 5.1,
    height: 10.73,
    transform: "matrix(4.53, 0, 0, -4.53, 340.09, 139.24)",
    xlinkHref: "#a413485c-3f95-41a2-b91e-21d934a7959a"
  }), /*#__PURE__*/React.createElement("use", {
    id: "fc2ed9d3-3fbc-415a-a490-72abe26c351c",
    "data-name": "use3830",
    width: 2.2,
    height: 12,
    transform: "matrix(4.53, 0, 0, -4.53, 367.87, 138.67)",
    xlinkHref: "#bd3fbdd7-4ebd-4301-a9e5-f982fb5d26f0"
  }), /*#__PURE__*/React.createElement("use", {
    id: "f262c7cc-053a-4cb9-8711-4e2de6b38e72",
    "data-name": "use3834",
    width: 7.8,
    height: 8.66,
    transform: "matrix(4.53, 0, 0, -4.53, 380.61, 139.87)",
    xlinkHref: "#afcee1fe-c3aa-49d4-babd-bdaf96f31baf"
  }), /*#__PURE__*/React.createElement("use", {
    id: "b0a6c39e-8489-4372-a705-46fd7d14502a",
    "data-name": "use3836",
    width: 6.8,
    height: 8.66,
    transform: "matrix(4.53, 0, 0, -4.53, 419.44, 139.87)",
    xlinkHref: "#af3309e3-b12f-437e-a000-dc1870dff519"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "aa4722a4-b65d-462d-ba2f-1de5b98b5d51",
    "data-name": "g6628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bc8316a1-9b0a-4d07-84fd-c90d292fe7d3",
    "data-name": "path3806",
    d: "M94.9,18.1v114c0,12.7,8.8,19.8,18.2,19.8s18.1-6,18.1-19.8V19c0-11.7-8.6-19-18.1-19S94.9,8.1,94.9,18.1Z",
    transform: "translate(0 0)",
    style: {
      fill: "#f8ab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "f7b836d7-4398-4d4a-916b-c68235d53ee1",
    "data-name": "path3808",
    d: "M47.5,76v56.1c0,12.7,8.8,19.8,18.1,19.8s18.1-6,18.1-19.8V76.8c0-11.7-8.6-19-18.1-19A18.4,18.4,0,0,0,47.5,76Z",
    transform: "translate(0 0)",
    style: {
      fill: "#e37300"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b08fdfa6-20ad-46b7-98b3-e5751a1db5a2",
    "data-name": "path3810",
    d: "M36.3,133.8a18.2,18.2,0,1,1-18.2-18.1,18.2,18.2,0,0,1,18.2,18.1",
    transform: "translate(0 0)",
    style: {
      fill: "#e37300"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleAnalytics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-analytics.505f4974.svg";
export { ForwardRef as ReactComponent };